import type { NavigationMenuItemInterfaceNavigate } from "@dealer-center/ddc-api-commoncontainer-interface";

export const openClickedItem = (
  itemClicked: NavigationMenuItemInterfaceNavigate
) => {
  if (itemClicked.link) {
    window.open(itemClicked.link, "_blank")?.focus();
  }
};
export const getInitialsFromName = (name: string) =>
  name
    .split(" ")
    .map(word => word[0])
    .join("");
